import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/error")({
  component: RouteComponent,
});

function RouteComponent() {
  throw new Error(`sentry test error @ ${new Date().toISOString()}`);
}
